import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  energyReports: [],
  isLoading: false,
  error: null,
  energyReportsDownload: [],
  isLoadingEnergyReportsDownload: false,
};

export const getEnergyReports: any = createAsyncThunk(
  "content/getEnergyReports",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    energyConsumptionChartType = null,
    startDate = null,
    endDate = null,
    timePeriod = 1,
    asset = null,
    energyRate = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      energyConsumptionChartType,
      startDate,
      endDate,
      timePeriod,
      asset,
      energyRate,
    };
    const res = await axios.post(`/slpapp/Report/getEnergyReport`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const downloadEnergyReportsFile: any = createAsyncThunk(
  "content/downloadEnergyReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    energyConsumptionChartType = null,
    startDate = null,
    endDate = null,
    timePeriod = 1,
    asset = null,
    energyRate = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      energyConsumptionChartType,
      startDate,
      endDate,
      timePeriod,
      asset,
      energyRate,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getEnergyReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType == "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      // if (fileType == "downloadPdf") {
      //   link.download = filename;
      // } else {
      //   link.download = filename;
      // }
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading energy report:", error);
      throw error;
    }
  },
);

export const energyReportSlice = createSlice({
  name: "energyReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEnergyReports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getEnergyReports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.energyReports = action.payload;
    });
    builder.addCase(getEnergyReports.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(downloadEnergyReportsFile.pending, (state) => {
      state.isLoadingEnergyReportsDownload = true;
    });
    builder.addCase(downloadEnergyReportsFile.fulfilled, (state, action) => {
      state.isLoadingEnergyReportsDownload = false;
      state.energyReportsDownload = action.payload;
    });
    builder.addCase(downloadEnergyReportsFile.rejected, (state, action) => {
      state.isLoadingEnergyReportsDownload = false;
      state.error = action.error.message;
    });
  },
});

export default energyReportSlice.reducer;
